import { createQueryKeys } from "@lukemorales/query-key-factory"

export default createQueryKeys("reports", {
  listReports: () => ({
    queryKey: ["reports"],
  }),
})
